var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "status",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,14.4999973 C5.79814906,14.4989924 5.6167018,14.3767128 5.54,14.19 L3.165,8.5 L1,8.49999734 L1,7.49999734 L3.5,7.49999734 C3.70185094,7.50100757 3.8832982,7.62328725 3.96,7.81 L5.96,12.645 L10.03,1.825 C10.103232,1.62899655 10.2907637,1.49932033 10.5,1.49999734 C10.7112719,1.50369129 10.8974149,1.63979584 10.965,1.84 L12.86,7.5 L15,7.49999734 L15,8.49999734 L12.5,8.49999734 C12.285042,8.50055488 12.0937861,8.36365586 12.025,8.16 L10.47,3.5 L6.47,14.18 C6.39513331,14.3740349 6.20797218,14.5014638 6,14.4999973 Z",
    id: "status"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.a530fa05af9c22eff026738988b6efc7.svg";
export { ForwardRef as ReactComponent };